import React from 'react';
import { Typography, styled } from '@mui/material';

const Heading = ({ serialNumber, children, ...rest }) => (
  <StyledTypography variant='h4' {...rest}>
    <HighlightedText>0{serialNumber}.</HighlightedText>
    {children}
  </StyledTypography>
);

export default Heading;

const StyledTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.slate.lighter,
  textTransform: 'capitalize',
  marginBottom: theme.spacing(5),

  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    transform: 'translate(5%, -50%)',
    backgroundColor: theme.palette.slate.dark,
    height: '1px',
    width: '18rem',

    [theme.breakpoints.down('md')]: {
      width: '9rem',
      transform: 'translate(15%, -50%)',
    },

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.7rem',
    textAlign: 'center',
  },
}));

const HighlightedText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
  marginRight: '1rem',
}));
